import { useNavigate } from "react-router-dom";

const FooterView = () => {
  const navigate = useNavigate();

  const currentYear = new Date().getFullYear();

  const onclickContactUs = () => navigate("/contact-us");
  const onclickAboutUs   = () => navigate("/about");
  const onclickPrivacy   = () => navigate("/privacy-notice");

  return (
    <div>
      {/* ── Web footer ── */}
      <div className="footer_web">
        <div className="footer">
          <div className="footer__center">
            <div className="footer_row_new">
              <div className="footer_tab">
                <a onClick={onclickAboutUs}>About</a>
              </div>
              <div className="footer_tab">|</div>
              <div className="footer_tab">
                <a onClick={onclickPrivacy}>Privacy Policy</a>
              </div>
              <div className="footer_tab">|</div>
              <div className="footer_tab">
                <a onClick={onclickContactUs}>Contact Us</a>
              </div>
            </div>
            <div className="footer_row">
              <div className="footer_tab">
                <p>Copyright © {currentYear} appétit, Buffalo New York - All Rights Reserved</p>
              </div>
            </div>
            <div className="footer_row">
              <div className="footer_tab">
                <p>Powered by - SavyCraft | Ark Digital</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Mobile footer ── */}
      <div className="footer_mobile">
        <div className="footer">
          <div className="footer__center">
            <div className="footer_row_new">
              <div className="footer_tab">
                <a onClick={onclickAboutUs}>About</a>
              </div>
              <div className="footer_tab">|</div>
              <div className="footer_tab">
                <a onClick={onclickPrivacy}>Privacy Policy</a>
              </div>
              <div className="footer_tab">|</div>
              <div className="footer_tab">
                <a onClick={onclickContactUs}>Contact Us</a>
              </div>
            </div>
            <div className="footer_row">
              <div className="footer_tab">
                <p className="hidden-xs">
                  Copyright © {currentYear} appétit, Buffalo New York - All Rights Reserved
                </p>
                <p className="visible-xs">
                  Copyright © {currentYear} appétit, Buffalo New York<br />All Rights Reserved
                </p>
              </div>
            </div>
            <div className="footer_row">
              <div className="footer_tab">
                <p>Powered by - SavyCraft | Ark Digital</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterView;